import {
  ANALYTICS_PAGE_NAMES,
  API_CATEGORY_TYPES,
  CUSTOM_ANALYTICS_EVENT_NAMES,
  getAnalyticPageNameByCategory,
  getAnalyticsUserDetails,
  getLoggedInUserInfo,
  isExternalLink,
  logEvent,
  PageNames,
  PlatformNames,
  useAppSelector,
  WEB_URL,
} from '@shalina-app/shared';
import parse from 'html-react-parser';
import { MarketingCardProps } from '.';
import { URLConstant } from '../../../../routes';
import {
  getImageSrc,
  retrieveData,
  STORAGE_CONSTANTS,
  useNavigatePageUtils,
  UserInterface,
} from '../../../../utils';
import styles from './homeBanner.module.scss';
import { appInsights } from '../../../../applicationInsight';
import { useCardViewTracker } from '../../hooks/useFeaturedCardViewTracker.component';

// ✅ New hook import

export const MarketingCardComponent: React.FC<MarketingCardProps> = ({
  content,
  isMobile,
}) => {
  const navigatePage = useNavigatePageUtils();
  const { urls } = URLConstant;
  const userInfo = useAppSelector(getLoggedInUserInfo);
  const user: UserInterface | any = retrieveData(STORAGE_CONSTANTS.USER);
  const isLoggedIn: boolean = retrieveData(STORAGE_CONSTANTS.IS_LOGGED_IN);

  // ✅ Hook for view tracking
  const cardRef = useCardViewTracker({
    nid: String(content?.nid),
    title: content?.title || '',
    type: 'marketing',
    userDetails: userInfo,
  });

  const extractRemainingPath = (url: string, baseUrl: string) => {
    if (url?.startsWith(baseUrl)) {
      return url?.slice(baseUrl?.length);
    } else {
      return url;
    }
  };

  const handleButtonClick = async (item: any) => {
    logEvent(appInsights, 'pageView', ANALYTICS_PAGE_NAMES.FEATURED_CONTENT);
    if (isLoggedIn && user) {
      const userObj = userInfo || user;
      const userData = getAnalyticsUserDetails(userObj);

      logEvent(
        appInsights,
        'custom',
        CUSTOM_ANALYTICS_EVENT_NAMES.USER_MOST_PAGE_VIEWED,
        {
          userEmail: userData?.emailId,
          userMobile: userData?.mobile,
          userName: userData?.name,
          userQualification: userData?.qualification,
          userInterest: userData?.areaOfInterest,
          userSpecialization: userData?.specialization,
          userCountryOfPractice: userData?.countryOfPractice,
          userPreferredLanguage: userData?.preferredLanguage,
          moduleName:
            getAnalyticPageNameByCategory(API_CATEGORY_TYPES.MARKETING) || '',
          pageName: `${getAnalyticPageNameByCategory(
            API_CATEGORY_TYPES.FEATURED_CONTENT
          )} ${PageNames?.LANDING}`,
          platform: PlatformNames.WEB,
        }
      );

      logEvent(
        appInsights,
        'custom',
        CUSTOM_ANALYTICS_EVENT_NAMES.USER_MOST_VIEWED,
        {
          userEmail: userData?.emailId,
          userMobile: userData?.mobile,
          userName: userData?.name,
          userQualification: userData?.qualification,
          userInterest: userData?.areaOfInterest,
          userSpecialization: userData?.specialization,
          userCountryOfPractice: userData?.countryOfPractice,
          userPreferredLanguage: userData?.preferredLanguage,
          contentId: content?.nid || '',
          contentTitle: content?.title || '',
          moduleName:
            getAnalyticPageNameByCategory(API_CATEGORY_TYPES.MARKETING) || '',
          platform: PlatformNames.WEB,
        }
      );
    }

    if (isExternalLink(item?.link, WEB_URL)) {
      window.open(item?.link, '_blank');
    } else {
      const url = extractRemainingPath(item?.link, WEB_URL);
      const routeUrl = url?.includes('medical-news-feeds-listing')
        ? urls.rssListing
        : url;
      const navigateDetails = {
        isDynamicUrl: false,
      };
      navigatePage(routeUrl, navigateDetails);
    }
  };

  const description = content?.field_description
    ? parse(content?.field_description)
    : '';

  return (
    <div ref={cardRef} className={styles.marketingCard}>
      <img
        className={styles.marketingImg}
        src={
          isMobile
            ? content?.field_thumbnail_image &&
              getImageSrc(content?.field_thumbnail_image)
            : content?.field_detail_image &&
              getImageSrc(content?.field_detail_image)
        }
        alt='marketing image'
      />
      <div className={styles.marketingText}>
        <p>{description}</p>
        <div className={styles.btnWrapper}>
          {content?.field_buttons?.length > 0 &&
            content?.field_buttons.map((item: any) => (
              <button key={item?.title} onClick={() => handleButtonClick(item)}>
                <span>{item?.title}</span>
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};
